import React from 'react';
import formatDataForSelect from 'Shared/util/formatDataForSelect';

import { AdminFormTab } from 'Components/Admin/Form';

const contacts = [
  { id: 1, title: 'Bob Been' },
  { id: 2, title: 'Max Tool' },
];

const invoiceContacts = [
  { id: 1, title: 'Bob Been Invoice' },
  { id: 2, title: 'Max Tool Invoice' },
];

const orderContacts = [
  { id: 1, title: 'Bob Been Order' },
  { id: 2, title: 'Max Tool Order' },
];

const paymentContacts = [
  { id: 1, title: 'Bob Been Payment' },
  { id: 2, title: 'Max Tool Payment' },
];

function ContactsContentForm() {
  const handleSubmit = (data) => console.log(data);

  const formItems = [
    {
      subTitle: 'Establish contacts for each specificity. If you do not see the desired contact, you can add or edit.',
      items: [
        {
          type: 'select',
          name: 'primaryContact',
          label: 'Primary contact',
          subLabel: 'This person will be able to see all invoices and orders on his or her dashboard',
          placeholder: 'Select primary contact',
          options: formatDataForSelect(contacts),
          subForm: {
            items: [
              {
                type: 'text',
                name: 'firstName',
                label: 'First name',
                placeholder: 'Type first name',
              },
            ],
            onSubmit: handleSubmit,
          },
        }, {
          type: 'select',
          name: 'toInvoice',
          label: 'Recipients of invoices',
          subLabel: `Selected contacts will receive invoices via email and will be able to see all invoices via the dashboard dashboard`,
          placeholder: 'Select invoice contact',
          options: formatDataForSelect(invoiceContacts),
          multiple: true,
          subForm: {
            items: [
              {
                type: 'text',
                name: 'firstName',
                label: 'First name',
                placeholder: 'Type first name',
              },
            ],
            onSubmit: handleSubmit,
          },
        }, {
          type: 'select',
          name: 'forOrders',
          label: 'Recipients of orders',
          subLabel: `Selected contacts will receive orders via email and will be able to see all orders via the dashboard dashboard`,
          placeholder: 'Select order contact',
          options: formatDataForSelect(orderContacts),
          multiple: true,
          subForm: {
            items: [
              {
                type: 'text',
                name: 'firstName',
                label: 'First name',
                placeholder: 'Type first name',
              },
            ],
            onSubmit: handleSubmit,
          },
        }, {
          type: 'select',
          name: 'forPaymentNotifications',
          label: 'Payment notification recipients',
          subLabel: `Selected contacts will receive a notification upon successful arrival of the payment on an invoice`,
          placeholder: 'Select payment contact',
          options: formatDataForSelect(paymentContacts),
          multiple: true,
          subForm: {
            items: [
              {
                type: 'text',
                name: 'firstName',
                label: 'First name',
                placeholder: 'Type first name',
              },
            ],
            onSubmit: handleSubmit,
          },
        }, {
          type: 'select',
          name: 'forNotifications',
          label: 'Leaves notifications',
          subLabel: `Selected contacts will receive notifications about leave requests of the team, assigned to the project.`,
          placeholder: 'Select request contact',
          options: formatDataForSelect(paymentContacts),
          multiple: true,
          subForm: {
            items: [
              {
                type: 'text',
                name: 'firstName',
                label: 'First name',
                placeholder: 'Type first name',
              },
            ],
            onSubmit: handleSubmit,
          },
        },
      ],
    },
  ];

  return (
    <div className="contacts" data-testid="projects-contacts-form">
      <AdminFormTab
        formItems={formItems}
        isBlocks
      />
    </div>
  );
}

export default ContactsContentForm;
